import mod from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserPermissionsCard.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserPermissionsCard.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/UserProfileComponents/UserPermissionsCard.vue?vue&type=script&lang=js
// module id = 791
// module chunks = 31